import React, { useState, useEffect } from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import ReLoginModal from "../ReLoginModal";
import { toast, ToastContainer } from "react-toastify";

type Product = {
  name: string;
  description: string;
  unitOfMeasure: string;
  category: string;
  price: any;
  quantity: string;
  _id: string;
};

const AddCustomer = ({
  handleChanges,
  handleSubmit,
  sign,
  loading,
  handleCus,
}: any) => {
  const [getProduct, setGetProduc] = useState<Product[]>([]);
  const token = window.localStorage.getItem("token");
  const [reLogin, setReLogin] = useState(false)
  const [formErrors, setFormErrors] = useState({
    businessName: "",
    businessType: ""
  });

  const validateField = (fieldName: string, value: string | undefined) => {
    if (!value?.trim()) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: `${fieldName} is required`,
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "",
      }))
    }

  };

  const handleSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    validateField("businessName", sign.businessName);
    validateField("businessType", sign.businessType);

    if (!formErrors.businessName) {
      handleSubmit(e);
    }
  };

  function queryCustomer() {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get("https://apibiz.oneflaretech.com/api/inventory", {
        headers: headers,
      })
      .then((res) => {
        setGetProduc(res.data.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message)
        error.response.data.message === "jwt expired" || "jwt malformed"
          ? setReLogin(true)
          : setReLogin(false);
      });
  }

  const [banks, setGetBanks] = useState([]);

  function queryBank() {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get("https://apibiz.oneflaretech.com/api/settings", {
        headers: headers,
      })
      .then((res) => {
        setGetBanks(res.data.data.banks);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        error.response.data.message === "jwt expired" || "jwt malformed"
          ? setReLogin(true)
          : setReLogin(false);
      });
  }

  useEffect(() => {
    queryCustomer();
    queryBank();
  }, []);
  return (
    <div className="modal">
      <form onSubmit={handleSubmitForm} className="catModal adCus">
        <ToastContainer />
        <div className="catModalTop">
          <h4>Add New Customer</h4>
          <ImCancelCircle className="catCancel" onClick={handleCus} />
        </div>
        <div className="line"></div>
        {reLogin ? <ReLoginModal /> : null}
        <div className="catModalInput branchInput">
          <input
            type="text"
            required
            placeholder="Business Name*"
            name="businessName"
            value={sign.businessName}
            onChange={(e) => {
              handleChanges(e);
              validateField("businessName", e.target.value);
            }}
          />
          {formErrors.businessName && (
            <span className="error">{formErrors.businessName}</span>
          )}
          <div className="div modalDouble">
            <input
              type="text"
              required
              placeholder="Business Type*"
              name="businessType"
              value={sign.businessType}
              onChange={handleChanges}
            />
            <input
              type="number"
              required
              placeholder="Customer’s Phone Number*"
              name="phone"
              value={sign.phone}
              onChange={handleChanges}
              maxLength={15}
            />
          </div>
          <input
            type="text"
            required
            placeholder="Customer’s email address"
            name="email"
            value={sign.email}
            onChange={handleChanges}
          />
          {/* <input
            type="password"
            required
            placeholder="Customer’s Password"
            name="password"
            value={sign.password}
            onChange={handleChanges}
          /> */}
          <input
            type="text"
            required
            placeholder="Address"
            name="address"
            value={sign.address}
            onChange={handleChanges}
          />
          <input
            type="text"
            required
            placeholder="City"
            name="city"
            value={sign.city}
            onChange={handleChanges}
          />
          <input
            type="tel"
            required
            placeholder="State"
            name="state"
            value={sign.state}
            onChange={handleChanges}
          />
          <input
            type="text"
            required
            placeholder="Country"
            name="country"
            value={sign.country}
            onChange={handleChanges}
          />
          {/* <input
            type="text"
            required
            placeholder="₦ Amount in Customer Wallet"
            name="amount"
           value={sign.amount}
            onChange={handleChanges}
          /> */}

          {/* <select name="product" onChange={handleChanges} id="">
            <option value="">Select Product</option>
            {getProduct.map((pro, inx) => {
              return (
                <option key={inx} value={pro?._id}>
                  {pro?.name}
                </option>
              );
            })}
          </select>
          <select name="bank" onChange={handleChanges}>
            <option value="">Select Bank</option>
            {banks.map((bank: any, inx: number) => {
              return <option value={bank._id}>{bank.bankName}</option>;
            })}
          </select> */}
        </div>

        <div className="catModalBtn">
          <button type="submit" className="catBtn1">
            {loading ? (
              <CircularProgress
                style={{ color: "#fff", width: "25px", height: "25px" }}
              />
            ) : (
              "Create"
            )}
          </button>
          <button className="catBtn2" onClick={handleCus}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddCustomer;
